<template>
  <div class="tips">
    当前为用户ID: {{ stuId }} <span v-if="isTestUser">(测试)</span>
    购买模拟预览页面，无法实际支付，支付请使用购买链接！
  </div>
</template>
<script>
import { getUrlParams } from "../../../utils/getUrlParams";
export default {
  name: "loginFreeTips",
  computed: {
    stuId() {
      return getUrlParams()?.stuId;
    },
    // 判断是否为测试账号
    isTestUser() {
      return Number(this.stuId) <= 100000 || Number(this.stuId) >= 2000000000;
    },
  },
};
</script>
<style lang="less" scoped>
.tips {
  color: #000;
  font-size: 9px;
  text-align: center;
  padding: 10px 0;
  position: fixed;
  top: 0;
  width: 100%;
  background: rgba(252, 187, 63, 0.8);
  z-index: 3;
  height: 13px;
}
</style>
